
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { BrokerService, environment } from '@c4/core';

const pkg: {
  version: string
} = require('../../../package.json');

export interface AboutState {
  status?: {
    directorIP: string,
    directorMAC: string,
    swVersions: {
      brokerVersion: string,
      brokerVersionDate: string
    },
    versions: {
      Director: {
        version: string,
        builddate: string,
        buildtime: string
      }
    }
  },
  registration?: {
    Status: string
  },
  properties?: {
    date: string;
    name: string;
    latitude: string;
    longitude: string;
    cityName?: string;
  },
  available?: {
    primaryControllerUpdateAvailable: boolean
  }
  environment: string;
  composerVersion: string;
  composerVersionDate: string;
  stats?: {
    bootTime: string;
    cpuIdle: number;
    cpuTotal: number;
    currentTime: string;
    memTotal: number;
    memUsed: number;
  };
  address?: any;
}

const INITIAL_STATE: AboutState = {
  environment: environment.env,
  composerVersion: pkg.version,
  composerVersionDate: 'Unknown'
}

const STORE_NAME = 'ABOUT_COMPOSER';

export const ABOUT_ACTIONS = {
  SET_STATUS: `${STORE_NAME}:SET_STATUS`,
  SET_REGISTRATION: `${STORE_NAME}:SET_REGISTRATION`,
  SET_PROPERTIES: `${STORE_NAME}:SET_PROPERTIES`,
  SET_AVAILABLE: `${STORE_NAME}:SET_AVAILABLE`,
  SET_ADDRESS: `${STORE_NAME}:SET_ADDRESS`,
  SET_STATS: `${STORE_NAME}:SET_STATS`,
  CLEAR: `${STORE_NAME}:CLEAR`
}

export const aboutReducer = (state: AboutState = INITIAL_STATE, { type, payload }): AboutState => {
  switch (type) {

    case ABOUT_ACTIONS.SET_STATUS:
      let status = payload;
      status.versions = status.versions.reduce((map, obj) => {
        map[obj.name] = {
          version: obj.version,
          builddate: obj.builddate,
          buildtime: obj.buildtime,
        }

        return map;
      }, {});
      return Object.assign({}, state, { status: status });

    case ABOUT_ACTIONS.SET_REGISTRATION:
      return Object.assign({}, state, { registration: payload });

    case ABOUT_ACTIONS.SET_PROPERTIES:
      return Object.assign({}, state, { properties: payload });

    case ABOUT_ACTIONS.SET_AVAILABLE:
      return Object.assign({}, state, { available: payload });

    case ABOUT_ACTIONS.SET_ADDRESS:
      return Object.assign({}, state, { address: payload });

    case ABOUT_ACTIONS.SET_STATS:
      return Object.assign({}, state, { stats: payload });

    case ABOUT_ACTIONS.CLEAR:
      return Object.assign({}, INITIAL_STATE);

    default:
      return state;
  }
};

@Injectable()
export class AboutService {

  pkg: any;

  constructor(
    private store: Store<{ about: AboutState }>,
    private http: Http,
    private broker: BrokerService
  ) {
    this.broker.connected.filter(c => !!c).subscribe(this.onConnect);
    this.broker.connected.filter(c => !c).skip(1).subscribe(this.onDisconnect);

    this.store.select(s => s.about)
      .filter(a => !!a.properties && !!a.properties.latitude && !!a.properties.longitude)
      .map(a => a.properties)
      .take(1)
      .subscribe(props => {
        if (props.cityName) {
          this.store.dispatch({
            type: ABOUT_ACTIONS.SET_ADDRESS,
            payload: {
              address: props.cityName
            }
          });
        } else {
          this.geoCode(parseFloat(props.latitude), parseFloat(props.longitude))
        }
      });
  }

  private onConnect = (connected: boolean) => {
    this.broker.call({
      path: '/api/v1/platform_status'
    }).then(status => {
      this.store.dispatch({
        type: ABOUT_ACTIONS.SET_STATUS,
        payload: status
      })
    });

    this.broker.call({
      path: '/api/v1/registration'
    }).then(registration => {
      this.store.dispatch({
        type: ABOUT_ACTIONS.SET_REGISTRATION,
        payload: registration
      })
    });

    this.broker.call({
      path: '/api/v1/properties'
    }).then(properties => {
      this.store.dispatch({
        type: ABOUT_ACTIONS.SET_PROPERTIES,
        payload: properties
      })
    });

    this.broker.call({
      path: '/api/v1/agents/update_manager/versions_available'
    }).then(available => {
      this.store.dispatch({
        type: ABOUT_ACTIONS.SET_AVAILABLE,
        payload: available
      })
    });
  }

  private onDisconnect = (connected: boolean) => {
    this.store.dispatch({ type: ABOUT_ACTIONS.CLEAR });
  }

  private geoCode = (lat: number, lng: number) => {
    this.broker.call({
      path: `/api/v1/properties/geocode?location=${lat},${lng}`
    }).then(address => {
      if (!!address && !!address[0] && address[0].address) {
        this.store.dispatch({
          type: ABOUT_ACTIONS.SET_ADDRESS,
          payload: address[0]
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/about/about.service.ts